import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CalendarX2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Storno() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading"); // loading | ready | done | error
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Termin stornieren – PC Zulassungsdienst";
    axios.get(`${API}/bookings/${id}/cancel-info`, { params: { t: token } })
      .then((r) => { setInfo(r.data); setState("ready"); })
      .catch(() => setState("error"));
  }, [id, token]);

  const cancel = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/bookings/${id}/cancel`, { token });
      setState("done");
    } catch {
      setState("error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="shade-paper text-ink py-20 md:py-28 min-h-[70vh]" data-testid="storno-page">
      <div className="max-w-xl mx-auto px-6">
        <div className="rounded-2xl bg-white soft-card border border-ink/10 p-8 md:p-10">
          {state === "loading" && <p className="text-inkmuted">Termin wird geladen …</p>}
          {state === "error" && (
            <div data-testid="storno-error">
              <h1 className="dp pc-h2">Nicht gefunden</h1>
              <p className="mt-4 text-inkmuted">Dieser Termin existiert nicht mehr oder wurde bereits storniert.</p>
            </div>
          )}
          {state === "done" && (
            <div data-testid="storno-done">
              <CheckCircle2 className="text-plate" size={40} />
              <h1 className="dp pc-h2 mt-4">Termin storniert</h1>
              <p className="mt-4 text-inkmuted">Der Zeitraum ist wieder frei. {info?.name} wurde per E-Mail über die Absage informiert.</p>
            </div>
          )}
          {state === "ready" && info && (
            <div data-testid="storno-confirm">
              <CalendarX2 className="text-[#b42318]" size={40} />
              <h1 className="dp pc-h2 mt-4">Termin stornieren?</h1>
              <dl className="mt-6 grid grid-cols-[auto_1fr] gap-x-6 gap-y-2">
                <dt className="text-inkmuted">Kunde</dt><dd className="font-semibold">{info.name}</dd>
                <dt className="text-inkmuted">Telefon</dt><dd className="font-semibold">{info.phone}</dd>
                {info.rows.map((r) => (
                  <div key={r.label} className="contents"><dt className="text-inkmuted">{r.label}</dt><dd className="font-semibold">{r.value}</dd></div>
                ))}
              </dl>
              <p className="mt-6 text-sm text-inkmuted">Der Kunde bekommt automatisch eine Absage per E-Mail ({info.email}).</p>
              <div className="mt-8 flex flex-wrap gap-3">
                <button type="button" onClick={cancel} disabled={busy}
                  className="lb rounded-full bg-[#b42318] text-white px-6 py-4 transition-colors hover:bg-[#912018] disabled:opacity-60" data-testid="storno-confirm-btn">
                  {busy ? "Wird storniert …" : "Ja, Termin stornieren"}
                </button>
                <Link to="/" className="lb rounded-full border-2 border-ink px-6 py-4 transition-colors hover:bg-ink hover:text-paper" data-testid="storno-back-link">Nicht stornieren</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
